import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { ContainerType } from '../models/container-type.model';

@Injectable({
  providedIn: 'root',
})
export class ContainerTypeService {
  private apiUrl = environment.apiUrl + environment.containerTypePath;

  constructor(private http: HttpClient) {}

  getContainerTypes(): Observable<ContainerType[]> {
    return this.http.get<ContainerType[]>(this.apiUrl);
  }

  getContainerType(id: number): Observable<ContainerType> {
    return this.http.get<ContainerType>(`${this.apiUrl}/${id}`);
  }

  createContainerType(containerType: ContainerType): Observable<ContainerType> {
    return this.http.post<ContainerType>(this.apiUrl, containerType);
  }

  updateContainerType(id: number, containerType: ContainerType): Observable<ContainerType> {
    return this.http.put<ContainerType>(`${this.apiUrl}/${id}`, containerType);
  }

  disabledContainerType(containerType: ContainerType): Observable<any> {
    return this.http.put<any>(
      `${this.apiUrl}${environment.disabledPath}/${containerType.id}`,
      containerType,
    );
  }

  deleteContainerType(id: number): Observable<void> {
    return this.http.delete<void>(`${this.apiUrl}/${id}`);
  }
}
